import { ReducerActionRotaSP } from 'store/modules/types';

import { AtualizarParametroLocalidadeDetalheRequest, Types } from './types';

export function atualizarParametroLocalidadeDetalheRequest(
	token: string,
	data: AtualizarParametroLocalidadeDetalheRequest,
): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE,
		token,
		payload: data,
	};
}
export function atualizarParametroLocalidadeDetalheSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_SUCCESS,
		payload,
	};
}
export function atualizarParametroLocalidadeDetalheFailure(): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_FAILURE,
		payload: null,
	};
}
export function atualizarParametroLocalidadeDetalheClear(): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_CLEAR,
		payload: null,
	};
}
